import apiClient from '@/services/axios'

export async function getById(reportId) {
  var response = await apiClient.get(`/EodReports/${reportId}`)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get eod reports')
}
